import axios from './axios'

export const getServiceProvidersList = data =>
  axios.get(`/clients/service-providers`)

export const addClientAccessToProvider = data =>
  axios.post(`/jobs/assign-clients-to-service-provider`, data)

export const removeClientAccessFromProvider = data => 
  axios.post(`/jobs/remove-clients-from-service-provider`, data)

export const addServiceProvider = data => 
  axios.post(`/clients/add-service-provider`, data)